export default __webpack_public_path__ + "static/media/dass.3513d5b9.jpg";